/**
 * 通用状态标签
 * 适配 Ant Design 3.x：避免使用 Tag color 属性触发的 antd 主题色，直接走 style。
 *
 * 视觉规范（对齐 web后台.html 设计稿）：
 *  - 软底 + 小圆点（dot）：`Tag tone="green" dot`
 *  - 不传 dot 时退化为纯软底（默认）
 */
import React from 'react'

interface StatusTagProps {
  label: string
  color: string
  bg: string
  /** 是否在文字左侧渲染同色小圆点 */
  dot?: boolean
  /** 边框色：默认无边框（软底纯填充） */
  borderColor?: string
  style?: React.CSSProperties
}

const StatusTag: React.FC<StatusTagProps> = ({
  label,
  color,
  bg,
  dot = true,
  borderColor,
  style
}) => (
  <span
    className="mingyang-status-tag"
    style={{
      color,
      background: bg,
      border: borderColor ? `1px solid ${borderColor}` : 'none',
      ...style
    }}
  >
    {dot && (
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: 999,
          background: color,
          display: 'inline-block',
          marginRight: 2
        }}
      />
    )}
    {label}
  </span>
)

export default StatusTag
